import type {fancyOperations, FancyOk} from '@freckle/educator-entities/ts/openapi-clients'
import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export type DistrictAttrs = FancyOk<fancyOperations['getDistrictsR']>[0]

export async function fetchDistricts(): Promise<Array<DistrictAttrs>> {
  return fancyClient.GET('/2/districts').then(extractData)
}
